import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || (process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL.replace(/\/api$/, '') : 'http://localhost:5000');

const groupService = {
    createGroup: async (formData, token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const response = await axios.post(`${API_URL}/api/groups`, formData, config);
        return response.data;
    },

    getGroups: async (token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const response = await axios.get(`${API_URL}/api/groups`, config);
        return response.data;
    },

    requestJoin: async (groupId, token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const response = await axios.post(`${API_URL}/api/groups/${groupId}/join`, {}, config);
        return response.data;
    },

    approveJoinRequest: async (groupId, profileId, token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const response = await axios.post(`${API_URL}/api/groups/${groupId}/approve/${profileId}`, {}, config);
        return response.data;
    },

    toggleStatus: async (id, status, token) => {
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const response = await axios.put(`${API_URL}/api/groups/${id}/status`, { status }, config);
        return response.data;
    }
};

export default groupService;
